import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  AttendanceRedemptionRequest,
  AttendanceRegistrationResponse,
} from '../models';

@Injectable({
  providedIn: 'root',
})
export class AttendanceService {
  constructor(private http: HttpClient) {}

  registerAttendance(
    trainingId: string,
    code: string
  ): Observable<AttendanceRegistrationResponse> {
    const request: AttendanceRedemptionRequest = {
      attendanceRedemption: { code },
    };

    return this.http.post<AttendanceRegistrationResponse>(
      `${environment.apiurl}/api/v1.0/schedule-info/${trainingId}/attendance`,
      request
    );
  }
}
